import {createAction, props} from '@ngrx/store';


export const closeSubmenu = createAction(
    '[Mobile Search] Close SubMenu'
);

export const openSubmenu = createAction(
    '[Mobile Search] Open Submenu',
    props<{menuType: string}>()
);
